import { createContext, useContext } from "react";
const initialSetContentToDisplay = () => { };
export const NavigationContext = createContext({
    setContentToDisplay: initialSetContentToDisplay,
    resetContentToParent: () => { },
    closeMenu: () => { },
    setHeaderTitle: () => { },
});
export const useNavigationContext = () => useContext(NavigationContext);
//# sourceMappingURL=NavigationContext.js.map